import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import {
    forgotpassword,
    home,
    jobapplicationmanagement,
    jobopeningmanagement,
    signin,
    privacypolicy,
    editprofile,
    changepassword,
    cmseditor,
    jobopeningview,
    industrymanagement,
    addnewindustry,
    addnewcountry,
    Termsandcondition,
    statemanagement,
    addnewstate,
    citymanagement,
    addnewcity,
    resetpassword,
    category,
    faqcategory,
    fqasubcategory,
    faqaddeditsubcategory,
    faqsubcategory,
    compliance,
    creatnewopening,
    faq,
    gdprpolicy,
esgpolicy,
genderpaygap,
carbonreductionplan,
modernslaveryact,
contactus,
appointments,
blogs,
    addeditfaq,
    testimonial,
    viewblog,
    jobalert,
    clientpartner,
createnewblog,
viewjobopening,
clientAppointment,
viewfaq
} from './routingConsts'

import { AxiosInterceptor } from '../utils/request'
import { useAdminInfo } from '../context/AdminContextDetail'
import ProtectedRoutes from './ProtectedRoutes'

import Dashboard from '../pages/Dashboard'
import Signin from '../pages/Signin'
import Layout from '../components/Layout'
import JobOpeningManagement from '../pages/JobOpeningManagement/'
import JobApplicationManagement from '../pages/JobApplicationManagement/'
import ForgotPassword from '../pages/ForgotPassword/'
import PrivacyPolicy from '../pages/PrivacyPolicy'
import MyAccountLayout from '../components/Layout/MyAccountLayout'
import EditProfile from '../pages/EditProfile'
import ChangePassword from '../pages/ChangePassword'
import CMSEditor from '../pages/CMSEditor/CMSEditor'
import JobOpeningView from '../pages/JobOpeningView'
import IndustryManagement from '../pages/IndustryManagement'
import AddNewIndustry from '../pages/AddNewIndustry'
import AddNewCountry from '../pages/AddNewCountry'
import StateManagement from '../pages/StateManagement'
import AddNewState from '../pages/AddNewState'
import CityManagement from '../pages/CityManagement'
import AddNewCity from '../pages/AddNewCity'
import TermsandCondition from '../pages/Termsandcondition'
import PageNotFound404 from '../pages/PageNotFound404'
import ResetPassword from '../pages/ResetPassword/ResetPassword'
import Category from '../pages/Category/Category'
import FaqCategoryManagement from '../pages/FaqCategoryManagement'
import AddEditFaqSubCategory from '../pages/AddEditFaqSubCategory'
import FaqSubCategoryManagement from '../pages/FaqSubCategoryManagement'
import Compliance from '../pages/Compliance'
import CreatNewOpening from '../pages/CreatNewOpening'
import Faq from '../pages/Faq'
import GDPRPolicy from '../pages/GDPRPolicy'
import ESGPolicy from '../pages/ESGPolicy'
import GenderPayGap from '../pages/GenderPayGap'
import CarbonReductionPlan from '../pages/CarbonReductionPlan'
import ModernSlaveryAct from '../pages/ModernSlaveryAct'
import Contactus from '../pages/Contactus'
import Appointments from '../pages/Appointments'
import Blogs from '../pages/Blogs'
import AddEditFaq from '../pages/AddEditFaq/AddEditFaq'
import Testimonial from '../pages/Testimonial/Testimonial'
import CreateNewBlog from '../pages/CreateNewBlog/CreateNewBlog'
import ViewBlog from '../pages/ViewBlog/ViewBlog'
import JobAlert from '../pages/JobAlert/JobAlert'
import ClientPartner from '../pages/ClientPartner/ClientPartner'
import ClientAppoitment from '../pages/ClientAppoitment/ClientAppoitment'
import ViewJobOpening from '../pages/ViewJobOpening/ViewJobOpening'
import ViewFaq from '../pages/ViewFaq/ViewFaq'
const Routing = () => {
    const { currentUser } = useAdminInfo()

    return (
        <>
            <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
                <AxiosInterceptor>
                    <Routes>
                        <Route path={home} element={<Layout />}>
                            <Route
                                path={editprofile}
                                element={
                                    <MyAccountLayout>
                                        <EditProfile />
                                    </MyAccountLayout>
                                }
                            />
                            <Route
                                path={changepassword}
                                element={
                                    <MyAccountLayout>
                                        <ChangePassword />
                                    </MyAccountLayout>
                                }
                            />
                            <Route
                                index
                                element={
                                    <ProtectedRoutes>
                                        <Dashboard />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={jobopeningmanagement}
                                element={
                                    <ProtectedRoutes>
                                        <JobOpeningManagement />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={category}
                                element={
                                    <ProtectedRoutes>
                                        <Category />
                                    </ProtectedRoutes>
                                }
                            />

                            <Route path={addeditfaq} element={
                              <ProtectedRoutes>
                                  <AddEditFaq />
                              </ProtectedRoutes>
                            } />

                            <Route path={`${addeditfaq}/:faqId`} element={
                              <ProtectedRoutes>
                                  <AddEditFaq />
                              </ProtectedRoutes>
                            } />

                            <Route path={`${viewfaq}/:faqId`} element={
                              <ProtectedRoutes>
                                  <ViewFaq />
                              </ProtectedRoutes>
                            } />      

                            <Route path={faqcategory} element={
                              <ProtectedRoutes>
                                  <FaqCategoryManagement />
                              </ProtectedRoutes>
                            } />
                                 <Route path={faqsubcategory} element={
                              <ProtectedRoutes>
                                  <FaqSubCategoryManagement />
                              </ProtectedRoutes>
                            } />
                            <Route path={faqaddeditsubcategory} element={
                                <ProtectedRoutes>
                                    <AddEditFaqSubCategory />
                                </ProtectedRoutes>
                            } />
                            <Route path={createnewblog} element={
                                <ProtectedRoutes>
                                    <CreateNewBlog />
                                </ProtectedRoutes>
                            } />
                            <Route path={`${createnewblog}/:blogId`} element={
                                <ProtectedRoutes>
                                    <CreateNewBlog />
                                </ProtectedRoutes>
                            } />
                            <Route path={`${viewblog}/:blogId`} element={
                                <ProtectedRoutes>
                                    <ViewBlog />
                                </ProtectedRoutes>
                            } />
                            <Route path={`${viewjobopening}/:jobOpeningId`} element={
                                <ProtectedRoutes>
                                    <ViewJobOpening />
                                </ProtectedRoutes>
                            } />
                            <Route path={creatnewopening} element={
                                <ProtectedRoutes>
                                    <CreatNewOpening />
                                </ProtectedRoutes>
                            } />
                            <Route path={`${creatnewopening}/:jobOpeningId`} element={
                                <ProtectedRoutes>
                                    <CreatNewOpening />
                                </ProtectedRoutes>
                            } />
                            <Route path={faq} element={
                                <ProtectedRoutes>
                                    <Faq />
                                </ProtectedRoutes>
                            } />

                                <Route
                                path={`${faqaddeditsubcategory}/:subCategoryId`}
                                element={
                                    <ProtectedRoutes>
                                        <AddEditFaqSubCategory />
                                    </ProtectedRoutes>
                                }
                            />
                            
                            <Route
                                path={compliance}
                                element={
                                    <ProtectedRoutes>
                                        <Compliance />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={clientpartner}
                                element={
                                    <ProtectedRoutes>
                                        <ClientPartner />
                                    </ProtectedRoutes>
                                }
                            />
                             <Route
                                path={testimonial}
                                element={
                                    <ProtectedRoutes>
                                        <Testimonial />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={jobapplicationmanagement}
                                element={
                                    <ProtectedRoutes>
                                        <JobApplicationManagement />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={`${jobopeningview}/:jobOpeningId`}
                                element={
                                    <ProtectedRoutes>
                                        <JobOpeningView />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={privacypolicy}
                                element={
                                    <ProtectedRoutes>
                                        <PrivacyPolicy />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={Termsandcondition}
                                element={
                                    <ProtectedRoutes>
                                        <TermsandCondition />
                                    </ProtectedRoutes>
                                }
                            />
                              <Route
                                path={gdprpolicy}
                                element={
                                    <ProtectedRoutes>
                                        <GDPRPolicy />
                                    </ProtectedRoutes>
                                }
                            />
                                  <Route
                                path={esgpolicy}
                                element={
                                    <ProtectedRoutes>
                                        <ESGPolicy />
                                    </ProtectedRoutes>
                                }
                            />
                                        <Route
                                path={genderpaygap}
                                element={
                                    <ProtectedRoutes>
                                        <GenderPayGap />
                                    </ProtectedRoutes>
                                }
                            />
                              <Route
                                path={carbonreductionplan}
                                element={
                                    <ProtectedRoutes>
                                        <CarbonReductionPlan />
                                    </ProtectedRoutes>
                                }
                            />
                                <Route
                                path={modernslaveryact}
                                element={
                                    <ProtectedRoutes>
                                        <ModernSlaveryAct />
                                    </ProtectedRoutes>
                                }
                            />

                                    <Route
                                path={contactus}
                                element={
                                    <ProtectedRoutes>
                                        <Contactus />
                                    </ProtectedRoutes>
                                }
                            />

                            <Route
                                path={jobalert}
                                element={
                                    <ProtectedRoutes>
                                        <JobAlert />
                                    </ProtectedRoutes>
                                }
                            />

                                     <Route
                                path={blogs}
                                element={
                                    <ProtectedRoutes>
                                        <Blogs />
                                    </ProtectedRoutes>
                                }
                            />
                                       <Route
                                path={appointments}
                                element={
                                    <ProtectedRoutes>
                                        <Appointments />
                                    </ProtectedRoutes>
                                }
                            />

                                    <Route
                                path={clientAppointment}
                                element={
                                    <ProtectedRoutes>
                                        <ClientAppoitment />
                                    </ProtectedRoutes>
                                }
                            />

                            <Route
                                path={cmseditor}
                                element={
                                    <ProtectedRoutes>
                                        <CMSEditor />
                                    </ProtectedRoutes>
                                }
                            />

                            <Route
                                path={industrymanagement}
                                element={
                                    <ProtectedRoutes>
                                        <IndustryManagement />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={addnewindustry}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewIndustry />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={`${addnewindustry}/:industryId`}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewIndustry />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={addnewcountry}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewCountry />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={`${addnewcountry}/:countryId`}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewCountry />
                                    </ProtectedRoutes>
                                }
                            />
                        
                            <Route
                                path={statemanagement}
                                element={
                                    <ProtectedRoutes>
                                        <StateManagement />{' '}
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={addnewstate}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewState />{' '}
                                    </ProtectedRoutes>
                                }
                            />

                            <Route
                                path={citymanagement}
                                element={
                                    <ProtectedRoutes>
                                        <CityManagement />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={addnewcity}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewCity />
                                    </ProtectedRoutes>
                                }
                            />
                            <Route
                                path={`${addnewcity}/:cityId`}
                                element={
                                    <ProtectedRoutes>
                                        <AddNewCity />{' '}
                                    </ProtectedRoutes>
                                }
                            />
                        </Route>
                        <Route
                            path={signin}
                            element={
                                currentUser ? (
                                    <Navigate to={home} />
                                ) : (
                                    <Signin />
                                )
                            }
                        />
                        <Route
                            path={forgotpassword}
                            element={
                                currentUser ? (
                                    <Navigate to={home} />
                                ) : (
                                    <ForgotPassword />
                                )
                            }
                        />
                        <Route
                            path={resetpassword}
                            element={
                                currentUser ? (
                                    <Navigate to={home} />
                                ) : (
                                    <ResetPassword />
                                )
                            }
                        />
                        <Route
                            path={`${resetpassword}/:token`}
                            element={
                                currentUser ? (
                                    <Navigate to={home} />
                                ) : (
                                    <ResetPassword />
                                )
                            }
                        />
                        <Route path="*" element={<PageNotFound404 />} />
                    </Routes>
                </AxiosInterceptor>
            </BrowserRouter>
        </>
    )
}

export default Routing
